var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterNew({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#827c78",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.642 21.359a2.629 2.629 0 0 0 1.617-1.618H23v-1.763H12.26a2.629 2.629 0 0 0-4.966 0H3.606v1.763h3.688a2.629 2.629 0 0 0 3.348 1.618zm-1.747-2.5a.882.882 0 1 1 1.763 0 .882.882 0 0 1-1.763 0zM10.642 7.254a2.629 2.629 0 0 0 1.617-1.618H23V3.873H12.26a2.629 2.629 0 0 0-4.966 0H3.606v1.763h3.688a2.629 2.629 0 0 0 3.348 1.618zm-1.747-2.5a.882.882 0 1 1 1.763 0 .882.882 0 0 1-1.763 0zM15.93 14.306a2.629 2.629 0 0 0 1.619-1.617H23v-1.763h-5.451a2.629 2.629 0 0 0-4.965 0H3.606v1.763h8.978a2.629 2.629 0 0 0 3.347 1.617zm-1.745-2.499a.882.882 0 1 1 1.763 0 .882.882 0 0 1-1.763 0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterNew);
export default __webpack_public_path__ + "static/media/filter-new.b3b62d081f4eb9d9ccd21c18e29eb5ac.svg";
export { ForwardRef as ReactComponent };